import { OrgPermission } from '@equaliq/api-model-v2';
import type {
  DemoCustomRole,
  DemoOrganizationMember,
} from '../demoOrganizationData';

export const defJamMembers: DemoOrganizationMember[] = [
  {
    userId: 'user-1',
    orgEmail: 'mayowa.consultant@defjam.com',
    role: 'custom',
    customRoleName: 'Consultant',
    joinedDate: '2024-03-10T00:00:00Z',
    userProfile: {
      userId: 'user-1',
      firstName: 'Mayowa',
      lastName: 'Arogundade',
      displayName: 'Mayowa Arogundade',
      email: 'mayowa@example.com',
      accountType: 'executive',
    },
  },
  {
    userId: 'user-4',
    orgEmail: 'tunji@defjam.com',
    role: 'primary_owner',
    joinedDate: '2024-01-01T00:00:00Z',
    userProfile: {
      userId: 'user-4',
      firstName: 'Tunji',
      lastName: 'Balogun',
      displayName: 'Tunji Balogun',
      email: 'tunji@defjam.com',
      accountType: 'executive',
    },
  },
  {
    userId: 'user-7',
    orgEmail: 'jeff.harleston@defjam.com',
    role: 'admin',
    joinedDate: '2024-01-05T00:00:00Z',
    userProfile: {
      userId: 'user-7',
      firstName: 'Jeff',
      lastName: 'Harleston',
      displayName: 'Jeff Harleston',
      email: 'jeff.harleston@defjam.com',
      accountType: 'executive',
    },
  },
  {
    userId: 'user-8',
    orgEmail: 'nicole.billings@defjam.com',
    role: 'custom',
    customRoleName: 'A&R Lead',
    joinedDate: '2024-02-01T00:00:00Z',
    userProfile: {
      userId: 'user-8',
      firstName: 'Nicole',
      lastName: 'Billings',
      displayName: 'Nicole Billings',
      email: 'nicole.billings@defjam.com',
      accountType: 'executive',
    },
  },
  {
    userId: 'user-9',
    orgEmail: 'kecia.tatum@defjam.com',
    role: 'custom',
    customRoleName: 'Legal Lead',
    joinedDate: '2024-02-15T00:00:00Z',
    userProfile: {
      userId: 'user-9',
      firstName: 'Kecia',
      lastName: 'Tatum',
      displayName: 'Kecia Tatum',
      email: 'kecia.tatum@defjam.com',
      accountType: 'executive',
    },
  },
  {
    userId: 'user-10',
    orgEmail: 'marcus.reynolds@defjam.com',
    role: 'custom',
    customRoleName: 'Deal Coordinator',
    joinedDate: '2024-03-01T00:00:00Z',
    userProfile: {
      userId: 'user-10',
      firstName: 'Marcus',
      lastName: 'Reynolds',
      displayName: 'Marcus Reynolds',
      email: 'marcus.reynolds@defjam.com',
      accountType: 'executive',
    },
  },
  {
    userId: 'user-11',
    orgEmail: 'sasha.robinson@defjam.com',
    role: 'member',
    joinedDate: '2024-03-15T00:00:00Z',
    userProfile: {
      userId: 'user-11',
      firstName: 'Sasha',
      lastName: 'Robinson',
      displayName: 'Sasha Robinson',
      email: 'sasha.robinson@defjam.com',
      accountType: 'manager',
    },
  },
];

export const defJamCustomRoles: DemoCustomRole[] = [
  {
    customRoleId: 'role-dj-1',
    orgId: 'org-3',
    name: 'A&R Lead',
    description: 'Leads artist & repertoire strategy, deal origination, and talent development',
    permissions: [
      OrgPermission.view_all_deals,
      OrgPermission.view_all_files,
      OrgPermission.invite_users,
      OrgPermission.view_analytics,
    ],
    createdDate: '2024-01-15T00:00:00Z',
    createdByUserId: 'user-4',
    memberCount: 2,
  },
  {
    customRoleId: 'role-dj-2',
    orgId: 'org-3',
    name: 'Legal Lead',
    description: 'Manages legal affairs, contract review, and business affairs compliance',
    permissions: [
      OrgPermission.view_all_deals,
      OrgPermission.view_all_files,
      OrgPermission.view_analytics,
    ],
    createdDate: '2024-01-15T00:00:00Z',
    createdByUserId: 'user-4',
    memberCount: 1,
  },
  {
    customRoleId: 'role-dj-3',
    orgId: 'org-3',
    name: 'Deal Coordinator',
    description: 'Coordinates deal logistics, tracks deliverables, and manages timelines',
    permissions: [OrgPermission.view_all_deals, OrgPermission.view_all_files],
    createdDate: '2024-02-01T00:00:00Z',
    createdByUserId: 'user-4',
    memberCount: 1,
  },
  {
    customRoleId: 'role-dj-4',
    orgId: 'org-3',
    name: 'Consultant',
    description: 'External consultant with read access to assigned deals and files',
    permissions: [OrgPermission.view_all_deals, OrgPermission.view_all_files],
    createdDate: '2024-03-01T00:00:00Z',
    createdByUserId: 'user-4',
    memberCount: 1,
  },
];

export const defJamInvitations: Array<{
  orgInviteId: string;
  orgId: string;
  invitedEmail: string;
  role: 'member' | 'admin' | 'viewer' | 'custom';
  customRoleName?: string;
  invitedByUserId: string;
  invitedByProfile: { displayName: string; email: string };
  status: 'pending' | 'accepted' | 'declined' | 'expired';
  createdAt: string;
  expiresAt: string;
}> = [
  {
    orgInviteId: 'invite-dj-1',
    orgId: 'org-3',
    invitedEmail: 'a.white.mgmt@example.com',
    role: 'member',
    invitedByUserId: 'user-8',
    invitedByProfile: {
      displayName: 'Nicole Billings',
      email: 'nicole.billings@defjam.com',
    },
    status: 'pending',
    createdAt: '2026-03-10T10:00:00Z',
    expiresAt: '2026-04-10T10:00:00Z',
  },
  {
    orgInviteId: 'invite-dj-2',
    orgId: 'org-3',
    invitedEmail: 'livenation.rep@example.com',
    role: 'viewer',
    invitedByUserId: 'user-9',
    invitedByProfile: {
      displayName: 'Kecia Tatum',
      email: 'kecia.tatum@defjam.com',
    },
    status: 'pending',
    createdAt: '2026-03-08T14:30:00Z',
    expiresAt: '2026-04-08T14:30:00Z',
  },
  {
    orgInviteId: 'invite-dj-3',
    orgId: 'org-3',
    invitedEmail: 'nike.brand@example.com',
    role: 'viewer',
    invitedByUserId: 'user-10',
    invitedByProfile: {
      displayName: 'Marcus Reynolds',
      email: 'marcus.reynolds@defjam.com',
    },
    status: 'accepted',
    createdAt: '2026-02-20T09:15:00Z',
    expiresAt: '2026-03-20T09:15:00Z',
  },
];
